<div
  id="kt_app_sidebar"
  class="app-sidebar flex-column"
  data-kt-drawer="true"
  data-kt-drawer-name="app-sidebar"
  data-kt-drawer-activate="{default: true, lg: false}"
  data-kt-drawer-overlay="true"
  data-kt-drawer-width="225px"
  data-kt-drawer-direction="start"
  data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
>
  <!-- Logo section -->
  <div class="app-sidebar-logo px-9" id="kt_app_sidebar_logo">
    <div class="overflow-hidden">
      <img
        alt="Logo"
        src="assets/media/Dermalogic_white.png"
        class="h-35px"
      />
      <div class="hide-logo-area app-sidebar-logo-minimize"></div>
    </div>
    <!-- Toggle Sidebar Button -->
    <div
      id="kt_app_sidebar_toggle"
      class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
      data-kt-toggle="true"
      data-kt-toggle-state="active"
      data-kt-toggle-target="body"
      data-kt-toggle-name="app-sidebar-minimize"
    >
      <i class="fa-solid fa-arrow-left rotate-180"></i>
    </div>
  </div>
  <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
    <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper">
      <div
        id="kt_app_sidebar_menu_scroll"
        class="scroll-y my-5 mx-3 pb-4"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
        style="height: 45rem"
      >
        <!-- Sidebar top -->
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <ng-container *ngFor="let item of filteredSidebarItems.top">
            <div
              *ngIf="
                !item.authorizations.length ||
                item.authorizations.includes(currentUser?.role)
              "
              class="menu-item"
            >
              <!-- If Sub Items exist -->
              <ng-container *ngIf="item.subItems?.length; else itemLink">
                <div
                  data-kt-menu-trigger="click"
                  class="menu-item menu-accordion"
                >
                  <span class="menu-link cursor-pointer fs-14 fw-bold">
                    <span class="menu-icon">
                      <i class="fa-solid fa-user"></i>
                    </span>
                    <span class="menu-title">{{ item.title | translate }}</span>
                    <span class="menu-arrow"></span>
                  </span>
                  <div
                    class="menu-sub menu-sub-accordion"
                    style="display: none; overflow: hidden"
                    kt-hidden-height="125"
                  >
                    <div
                      *ngFor="let subItem of item.subItems"
                      class="menu-item"
                    >
                      <a class="menu-link" [routerLink]="[subItem.route]">
                        <span class="menu-bullet">
                          <span class="bullet bullet-dot"></span>
                        </span>
                        <span class="menu-title fs-14">{{
                          subItem.title | translate
                        }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- If Sub Items does not exist -->
              <ng-template #itemLink>
                <a class="menu-link" [routerLink]="[item.route]">
                  <span class="menu-icon">
                    <i [class]="item.icon"></i>
                  </span>
                  <span class="menu-title fs-14">{{
                    item.title | translate
                  }}</span>
                </a>
              </ng-template>
            </div>
          </ng-container>
        </div>

        <!-- Sidebar bottom -->
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold mt-15 mb-4 pb-8"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <ng-container *ngFor="let item of filteredSidebarItems.bottom">
            <div
              *ngIf="
                !item.authorizations.length ||
                item.authorizations.includes(currentUser?.role)
              "
              class="menu-item"
            >
              <!-- If Sub Items exist -->
              <ng-container *ngIf="item.subItems?.length; else bottomItemLink">
                <div
                  data-kt-menu-trigger="click"
                  class="menu-item menu-accordion"
                >
                  <span class="menu-link cursor-pointer fs-14 fw-bold">
                    <span class="menu-icon">
                      <i [class]="item.icon"></i>
                    </span>
                    <span class="menu-title">{{ item.title | translate }}</span>
                    <span class="menu-arrow"></span>
                  </span>
                  <div
                    class="menu-sub menu-sub-accordion"
                    style="display: none; overflow: hidden"
                    kt-hidden-height="125"
                  >
                    <div
                      *ngFor="let subItem of item.subItems"
                      class="menu-item"
                    >
                      <a class="menu-link" [routerLink]="[subItem.route]">
                        <span class="menu-bullet">
                          <span class="bullet bullet-dot"></span>
                        </span>
                        <span class="menu-title fs-14">{{
                          subItem.title | translate
                        }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- If Sub Items does not exist -->
              <ng-template #bottomItemLink>
                <a
                  class="menu-link"
                  [routerLink]="item.route ? [item.route] : null"
                  (click)="item.onClick && item.onClick()"
                >
                  <ng-container
                    *ngIf="item.value === 'profile'; else otherIcons"
                  >
                    <span class="menu-icon symbol">
                      <img
                        [src]="userAvatar"
                        [alt]="currentUser?.name + ' ' + currentUser?.lastName"
                        class="rounded-circle avatar"
                      />
                    </span>
                  </ng-container>
                  <ng-template #otherIcons>
                    <span class="menu-icon">
                      <i [class]="item.icon"></i>
                    </span>
                  </ng-template>

                  <ng-container
                    *ngIf="item.value === 'profile'; else otherTitles"
                  >
                    <span class="menu-title fw-bold fs-14">
                      {{ currentUser?.name || "" }}
                      {{ currentUser?.lastName || "" }}
                    </span>
                  </ng-container>
                  <ng-template #otherTitles>
                    <span class="menu-title fs-14">{{
                      item.title | translate
                    }}</span>
                  </ng-template>
                </a>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
